import React from 'react';
import { CoreTeam} from '../components';
import './pages.css';

const TeamPage = () => {
  return (
    <div className="page page--team">
      <section className="page__hero page__hero--team page__hero--compact page__hero--team-compact">
        <div className="page__hero-content">
          <h1 className="gradient__text page__hero-title">Our Team</h1>
        </div>
      </section>

      <div className="section__padding">
        <CoreTeam />
      </div>
    </div>
  );
};

export default TeamPage;
